import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import api from '../../services/api';
import apiDAM from '../../services/apiDAM';
import { login } from '../../services/auth';
import PageDefault from '../../components/PageDefault';

export default function GovBrCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const [carregando, setCarregando] = React.useState(true);
  const hasExchangedRef = React.useRef(false);

  React.useEffect(() => {
    if (hasExchangedRef.current) return;
    hasExchangedRef.current = true;

    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const state = queryParams.get('state');

    const storedState = sessionStorage.getItem('govbr_state');
    const codeVerifier = sessionStorage.getItem('govbr_pkce_verifier');
    const redirectAfterLogin = sessionStorage.getItem('post_login_redirect') || '/';

    if (!code || !state) {
      toast.error('Retorno do gov.br inválido: parâmetros ausentes.');
      setCarregando(false);
      navigate('/login', { replace: true });
      return;
    }

    if (!storedState || state !== storedState) {
      toast.error('Retorno do gov.br inválido: state não confere.');
      setCarregando(false);
      navigate('/login', { replace: true });
      return;
    }

    if (!codeVerifier) {
      toast.error('Sessão de login gov.br expirada (code_verifier ausente).');
      setCarregando(false);
      navigate('/login', { replace: true });
      return;
    }

    window.history.replaceState(null, '', location.pathname);

    const redirectUri = process.env.REACT_APP_GOVBR_REDIRECT_URI;
    const endpoint = '/user/login/govbr';

    api.post(endpoint, {
      code,
      codeVerifier,
      redirectUri,
    })
      .then((res) => {
        const token = res?.data?.token || res?.headers?.authorization || res?.headers?.authotization;
        if (!token) {
          toast.error('Token não retornado pelo servidor.');
          setCarregando(false);
          navigate('/login', { replace: true });
          return;
        }

        login(token);

        apiDAM.get('/')
          .then((res) => {
            console.log(res.data.Status);
          })
          .catch(() => {
            console.log('Erro ao iniciar serviço');
          });

        sessionStorage.removeItem('govbr_state');
        sessionStorage.removeItem('govbr_pkce_verifier');
        sessionStorage.removeItem('govbr_nonce');
        sessionStorage.removeItem('post_login_redirect');

        navigate(redirectAfterLogin, { replace: true });
      })
      .catch((err) => {
        const message = err?.response?.data?.message;
        toast.error(message || 'Falha ao concluir login gov.br');
        setCarregando(false);
        navigate('/login', { replace: true });
      });
  }, [location.pathname, location.search, navigate]);

  return (
    <PageDefault carregando={carregando} title="Login gov.br">
      <div />
    </PageDefault>
  );
}
